import { memo, useId } from 'react';

import { Card, Typography } from '@/ui';

import './styles.css';
import type { Props } from './types';

const MissionGroupCard = ({ title, count, aside, children }: Props) => {
  const headingId = useId();

  return (
    <Card padding="none" className="overflow-hidden">
      <section aria-labelledby={headingId}>
        <div className="flex flex-wrap items-center justify-between gap-2 border-b border-uniform-gray-200 bg-uniform-gray-50 px-5 py-3 dark:border-uniform-gray-700 dark:bg-uniform-gray-800">
          <Typography id={headingId} variant="label" as="h2" className="font-bold">
            {title} · {count}
          </Typography>
          {aside && (
            <Typography variant="caption" muted as="span">
              {aside}
            </Typography>
          )}
        </div>
        <ul className="divide-y divide-uniform-gray-100 dark:divide-uniform-gray-800">
          {children}
        </ul>
      </section>
    </Card>
  );
};

export default memo(MissionGroupCard);
